import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { StatsBand } from "@/components/StatsBand";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { Projects } from "@/components/Projects";
import { Testimonials } from "@/components/Testimonials";
import { Areas } from "@/components/Areas";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { StickyBar } from "@/components/StickyBar";

function App() {
  return (
    <div className="App text-gray-100 min-h-screen relative">
      {/* global cinematic grain */}
      <div className="grain fixed inset-0 z-[1] pointer-events-none opacity-[0.04] mix-blend-overlay" aria-hidden="true" />
      <div className="relative z-[2]">
        <Navbar />
        <main>
          <Hero />
          <Services />
          <Projects />
          <About />
          <Testimonials />
          <Areas />
          <Contact />
        </main>
        <Footer />
        <StickyBar />
      </div>
      <Toaster position="top-center" theme="dark" richColors />
    </div>
  );
}

export default App;
